<template>
  <div class="home">
    <!---头部--->
    <myHead></myHead>
    <!--用户信息--->
    <userInfo :userInfoFnc="userInfoFnc"></userInfo>
    <!--彩矿兑换列表--->
    <caikuangExchangeList :list="list" :institutional="institutional" :userInfoObj="userInfoObj" @catNameFnc="catNameFnc"></caikuangExchangeList>
    <!-- <myFoot></myFoot> -->
    <div style="width:100%;text-align: center;">
      <a href="https://beian.miit.gov.cn/" style="margin-top:100px;color:#000;font-size:14px">京ICP备2023039941号-1</a>
    </div>
  </div>
</template>

<script>
import myHead from './../../components/header.vue'
import myFoot from './../../components/foot.vue'
import userInfo from '@/view/home/components/userInfo'
import caikuangExchangeList from '@/view/home/components/caikuangExchangeList'
import { get } from './../../utils/httpService'
export default {
  name: 'home',
  data () {
    return {
      list: [],
      institutional: ['皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤', '皮肤'],
      userInfoObj: {}
    }
  },
  components: {
    myHead,
    userInfo,
    caikuangExchangeList,
    myFoot
  },
  created () {
    this.getCats()
  },
  methods: {
    async fetchData (name) {
      try {
        this.list = await get(`/api/shop/items?cat=${name}`)
        console.log('Fetched data:', this.list)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    async getCats () {
      try {
        this.institutional = await get('/api/shop/item/cats')
        this.institutional.unshift('全部')
        console.log('Fetched data:', this.institutional)
        this.fetchData('')
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    catNameFnc (e) {
      if (e === '全部')e = ''
      this.fetchData(e)
    },
    userInfoFnc (e) {
      this.userInfoObj = e
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.foot{font-size: 14px;margin-bottom: 20px;margin-top: 50px;width: 100%;display: flex;justify-content: center;}
.foot-b a{color: #000 !important; pointer-events: none;}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue